import React from "react";
import styled from "styled-components";
import { Row, Breadcrumb, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

export interface BreadCrumbItem {
    path: string;
    label: string;
    isActive?: boolean;
}

export interface HeaderSectionProps {
    title: string;
    description: string;
    breadCrumbs: BreadCrumbItem[]
}

function HeaderSection({title, description, breadCrumbs}: HeaderSectionProps){
    return (
        <PageTitles className="mx-0">
            <Col sm="6" className="p-md-0">
                <div className="page-title">
                    <PageTitle>{title}</PageTitle>
                    <PageDescription className="ml-1">{description}</PageDescription>
                </div>
            </Col>
            <Col sm="6" className="p-md-0 justify-content-sm-end mt-2 mt-sm-0 d-flex">
                <Breadcrumb>
                    {
                        breadCrumbs.map((breadCrumb, index) =>
                            <Breadcrumb.Item key={index} linkAs={Link} linkProps={{ to: breadCrumb.path }} active={breadCrumb.isActive}>{breadCrumb.label}</Breadcrumb.Item>
                        )
                    }
                </Breadcrumb>
            </Col>
        </PageTitles>
    );
}

const PageTitles = styled(Row)`
    padding: 0.9375rem 1.25rem;
    background: #fff;
    margin-bottom: 30px;
    border-radius: 5px;
`

const PageTitle = styled("h4")`
    margin-bottom: 0;
    margin-top: 0;
    color: ${props => props.theme.colors.main};
`

const PageDescription = styled("span")`
    color: ${props => props.theme.colors.textNeutral};
`

export default HeaderSection;